import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import SendIcon from "@material-ui/icons/Send";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  actionButton: {
    borderRadius: 20,
    marginRight: theme.spacing(1),
    // background: "#FFF",
    // color: theme.palette.primary.main,
    [theme.breakpoints.down("xs")]: {
      whiteSpace: "nowrap",
      fontSize: 10,
    },
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function QuickMenu(props) {
  const { actionRoutes, handleChange } = props;
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRedirect = () => {
    handleClose();
    handleChange(null, 7);
  };

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
        size={sm ? "small" : "medium"}
        className={classes.actionButton}
        endIcon={<ExpandMore />}
      >
        ⚡ Quick Pay
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem
          to={actionRoutes.quickpay.path}
          component={Link}
          onClick={handleRedirect}
        >
          <ListItemText primary="Bill Pay" />
        </StyledMenuItem>
        <StyledMenuItem
          to={actionRoutes.quicktopup.path}
          component={Link}
          onClick={handleRedirect}
        >
          <ListItemText primary="Top Up" />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
}
